import { Modal } from "antd";
import React, { memo, useEffect, useState } from "react";

const HandleCitation = memo(({ node, setShow, handleCancel, editor }) => {
  const [modifiedhref, setModifiedhref] = useState({
    href: "",
    "ref-type": "",
    rid: "",
    "data-mce-href": "",
    text: "",
  });
  const href = node?.getAttribute("href") || "";
  const ref_type = node?.getAttribute("ref-type") || "";
  const rid = node?.getAttribute("rid") || "";
  const data = node?.getAttribute("data-mce-href") || "";
  const text = node?.innerText;

  useEffect(() => {
    setModifiedhref({
      href: href,
      "ref-type": ref_type,
      rid: rid,
      "data-mce-href": data,
      text: text,
    });
  }, [href, ref_type, rid, data, text]);

  const handleChange = (e, type) => {
    if (type === "href") {
      setModifiedhref((prev) => ({ ...prev, href: e.target.value }));
    } else if (type === "ref-type") {
      setModifiedhref((prev) => ({ ...prev, "ref-type": e.target.value }));
    } else if (type === "rid") {
      setModifiedhref((prev) => ({ ...prev, rid: e.target.value }));
    } else if (type === "data-mce-href") {
      setModifiedhref((prev) => ({ ...prev, "data-mce-href": e.target.value }));
    } else {
      setModifiedhref((prev) => ({ ...prev, text: e.target.value }));
    }
  };

  const handleEditCitation = () => {
    console.log(modifiedhref);
    node.setAttribute("href", modifiedhref.href);
    node.setAttribute("ref-type", modifiedhref["ref-type"]);
    node.setAttribute("rid", modifiedhref.rid);
    node.setAttribute("data-mce-href", modifiedhref["data-mce-href"]);
    node.innerHTML = modifiedhref.text;
    handleCancel();
  };

  return (
    <Modal
      title="Edit Citation"
      open={setShow}
      onOk={handleEditCitation}
      maskClosable={false}
      onCancel={handleCancel}
      zIndex={10}
    >
      <div className="flex w-full flex-col gap-4">
        <div className="flex flex-col gap-1 w-full">
          <label className="w-full">Link :</label>
          <input
            className="px-2 border-[1px] outline-[#006CE7] border-[#eeeeee] w-full rounded-[6px] py-3"
            type="text"
            value={modifiedhref.href || ""}
            onChange={(e) => handleChange(e, "href")}
          />
        </div>
        <div className="flex flex-col gap-1 w-full">
          <label className="w-full">Ref-Type :</label>
          <input
            className="px-2 border-[1px] outline-[#006CE7] border-[#eeeeee] w-full rounded-[6px] py-3"
            type="text"
            value={modifiedhref["ref-type"] || ""}
            onChange={(e) => handleChange(e, "ref-type")}
          />
        </div>
        <div className="flex flex-col gap-1 w-full">
          <label className="w-full">rid :</label>
          <input
            className="px-2 border-[1px] outline-[#006CE7] border-[#eeeeee] w-full rounded-[6px] py-3"
            type="text"
            value={modifiedhref["rid"] || ""}
            onChange={(e) => handleChange(e, "rid")}
          />
        </div>
        <div className="flex flex-col gap-1 w-full">
          <label className="w-full">data-mce-href :</label>
          <input
            className="px-2 border-[1px] outline-[#006CE7] border-[#eeeeee] w-full rounded-[6px] py-3"
            type="text"
            value={modifiedhref["data-mce-href"] || ""}
            onChange={(e) => handleChange(e, "data-mce-href")}
          />
        </div>
        <div className="flex flex-col gap-1 w-full">
          <label className="w-full">Text :</label>
          <input
            className="px-2 border-[1px] outline-[#006CE7] border-[#eeeeee] w-full rounded-[6px] py-3"
            type="text"
            value={modifiedhref["text"] || ""}
            onChange={(e) => handleChange(e, "text")}
          />
        </div>
      </div>
    </Modal>
  );
});

export default HandleCitation;
